// Дизайн-система проекта: база martyrs (слои @layer) + JIT-утилиты + тема проекта.
// Всё внутри @/design-system/index.js — единая точка подключения.
import '@/design-system/index.js';

import { createUniversalApp } from '@ozdao/martyrs/modules/core/client';

import { getConfig } from '@/configs/global.config.js';
import { getRouter } from '@/router/index.js';
import { getStore } from '@/store/index.js';
import { getLocales } from '@/localization/index.js';

const appPromise = createUniversalApp({
  getConfig,
  getRouter,
  getLocales,
  getStore,
  // afterInitialize стреляет в конце initialize() в core.app.js — на этот момент
  // app уже создан и core-плагины подключены.
  getHooks: {
    afterInitialize: ({ app }) => {
      // Редактор дизайн-токенов (Ctrl+Shift+D). Импорт внутри проверки на
      // NODE_ENV, а не статический: DefinePlugin подставляет константу, ветка
      // в проде становится мёртвой и чанк панели вообще не собирается.
      if (process.env.NODE_ENV !== 'production') {
        import('@martyrs/src/design-system/devtools/devtools.plugin.js')
          .then(m => app.use(m.default));
      }
    },
  },
});

export async function _renderApp({ url, cookies, languages, ssrContext }) {
  const { renderApp } = await appPromise;

  return renderApp({ url, cookies, languages, ssrContext });
}
